<script lang="ts">
  import Parse from 'parse/dist/parse';
  import { onMount } from 'svelte';
  import { blur, fly } from 'svelte/transition';
  import { flip } from 'svelte/animate';

  Parse.serverURL = 'https://parse01.console.paas.jesseola.com/parse';
  Parse.initialize('appid');

  let nameInput: HTMLInputElement;
  let name: string;
  let age: number;
  let people: Parse.Object[] = [];
  let subscription: Parse.LiveQuerySubscription;

  onMount(async () => {
    const peopleQuery = new Parse.Query('Person');

    peopleQuery.descending('createdAt');
    people = await peopleQuery.find();

    subscription = await peopleQuery.subscribe();
    subscription.on('create', (o) => (people = [o, ...people]));
    subscription.on('update', (o) => {
      people = people.filter((obj) => (obj.id === o.id ? o : obj));
    });
    subscription.on('delete', (o) => {
      people = people.filter((obj) => obj.id !== o.id);
    });
  });

  async function loginAnon() {
    const authData = { anonymous: { id: +new Date() } };
    const user = Parse.U;
  }
</script>

<main>
  <form
    on:submit|preventDefault={async () => {
      name = name.trim();
      age = Number(age);
      if (!age || !age) return;

      const obj = new Parse.Object('Person');
      obj.set('name', name);
      obj.set('age', age);

      await obj.save();
      name = age = undefined;
      nameInput.focus();
    }}
  >
    <input
      bind:this={nameInput}
      type="text"
      placeholder="Name"
      bind:value={name}
    />
    <input type="number" placeholder="Age" bind:value={age} />
    <button>Create Person</button>
    <button type="button" on:click={loginAnon}>Login Anon</button>

    <button type="button" on:click={() => console.log(Parse.User.current())}
      >Get current user</button
    >

    <button
      type="button"
      on:click={async () => {
        const res = await Parse.Cloud.run('hello');
        alert(res);
      }}>Call Function</button
    >
  </form>

  <div>
    <h1>Parse People</h1>
    <ul>
      {#each people as person, i (person.id)}
        <li in:blur|local out:fly={{ x: -150, duration: 200 }} animate:flip>
          <span>{person.get('name')} is {person.get('age')} years old.</span>
          <button
            on:click={async () => {
              await person.destroy();
            }}>delete</button
          >
        </li>
      {:else}
        <p>There are no people to show.</p>
      {/each}
    </ul>
  </div>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  ul {
    width: max-content;
    margin: 0 auto;
  }

  ul li {
    display: flex;
  }

  ul li span {
    flex: 1;
    text-align: left;
    padding-right: 2rem;
  }

  input,
  button {
    border: none;
    border-radius: 5px;
    outline: none;
  }

  input {
    background: rgba(0, 0, 0, 0.03);
  }

  button {
    font-weight: bold;
    cursor: pointer;
    padding: auto 1rem;
    transition: 0.3s ease-out;
  }

  button:hover {
    filter: brightness(0.9);
  }

  ul li button {
    color: white;
    background: red;
    font-size: 0.8rem;
    letter-spacing: 0.5px;
  }

  ul li button:hover {
    filter: brightness(2);
  }

  button:not(ul li button) {
    background: white;
    border: 1px solid #01cf83;
    color: #01cf83;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
